import React from 'react';
import { validateStep2 } from '../lib/onboardingSchema';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function ReviewGoalStep({ data, onChange, onNext, onBack }) {
  const isValid = validateStep2(data);

  const handleChannelToggle = (key) => {
    onChange('channels', {
      ...data.channels,
      [key]: !data.channels[key]
    });
  };

  return (
    <div className="space-y-8 animate-fadeIn">
      <div>
        <h3 className="text-xl text-brand-deep mb-2">Define your reputation goals</h3>
        <p className="text-gray-600">How do you want to interact with your customers to get reviews?</p>
      </div>

      <div className="space-y-6">
        <div>
          <label className="label-text">Primary Review Goal *</label>
          <select 
            className="input-field"
            value={data.primaryGoal}
            onChange={(e) => onChange('primaryGoal', e.target.value)}
            style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
          >
            <option value="">Select a goal...</option>
            <option value="Increase overall star rating">Increase overall star rating</option>
            <option value="Get more recent reviews">Get more recent reviews</option>
            <option value="Recover from negative reviews">Recover from negative reviews</option>
            <option value="Dominate local SEO search">Dominate local SEO search</option>
          </select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="label-text">Current Monthly Reviews</label>
            <input 
              type="number" 
              className="input-field" 
              placeholder="e.g. 2"
              value={data.currentReviews}
              onChange={(e) => onChange('currentReviews', e.target.value)}
              style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
            />
          </div>
          <div>
            <label className="label-text">Desired Monthly Reviews</label>
            <input 
              type="number" 
              className="input-field" 
              placeholder="e.g. 15"
              value={data.desiredReviews}
              onChange={(e) => onChange('desiredReviews', e.target.value)}
              style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
            />
          </div>
        </div>

        <div>
          <label className="label-text mb-3">Preferred Request Channels * (Select at least one)</label>
          <div className="grid grid-cols-2 gap-4">
            {[
              { id: 'sms', label: 'SMS / Text', icon: FiIcons.FiMessageSquare },
              { id: 'email', label: 'Email', icon: FiIcons.FiMail },
              { id: 'qrCode', label: 'QR Code', icon: FiIcons.FiMaximize },
              { id: 'website', label: 'Website Link', icon: FiIcons.FiLink }
            ].map(channel => (
              <label key={channel.id} className={`flex items-center p-4 border rounded-lg cursor-pointer transition-all ${data.channels[channel.id] ? 'border-brand-accent bg-brand-accent/5' : 'border-gray-200 hover:border-brand-signal'}`}>
                <input 
                  type="checkbox" 
                  className="hidden"
                  checked={data.channels[channel.id]}
                  onChange={() => handleChannelToggle(channel.id)}
                />
                <SafeIcon icon={channel.icon} className={`mr-3 text-xl ${data.channels[channel.id] ? 'text-brand-accent' : 'text-gray-400'}`} />
                <span className={data.channels[channel.id] ? 'text-brand-deep font-medium' : 'text-gray-600'}>{channel.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div>
          <label className="label-text">Brand Tone Preference</label>
          <select 
            className="input-field"
            value={data.tone}
            onChange={(e) => onChange('tone', e.target.value)}
            style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
          >
            <option value="Professional">Professional & Polished</option>
            <option value="Friendly">Friendly & Casual</option>
            <option value="Direct">Direct & Concise</option>
            <option value="Warm">Warm & Local</option>
          </select>
        </div>
      </div>

      <div className="pt-6 mt-6 border-t border-gray-100 flex justify-between">
        <button onClick={onBack} className="btn-secondary">
          Back
        </button>
        <button 
          onClick={onNext} 
          disabled={!isValid}
          className="btn-primary"
        >
          Continue to Integration <SafeIcon icon={FiIcons.FiArrowRight} />
        </button>
      </div>
    </div>
  );
}